import {useEffect} from 'react'
import {Outlet} from 'react-router'

import {useTrackMaintainEvent} from '../../../shared/hooks/useTrackMaintain'
import {PMContainer} from '../components/PM'

export const PmMain = () => {
  const trackMaintainEvent = useTrackMaintainEvent()

  useEffect(() => {
    trackMaintainEvent({
      name: 'kmsUserLoggedIn'
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Outlet />
}

export const PmInternalRoutes = [
  {
    index: true,
    element: <PMContainer />
  }
]
